<template>
    <span v-if="visible" class="d-block text-red text-no-nowrap text-caption">
        {{ $t('commission') }}:
        {{ $filters.price(commission) }}
    </span>
</template>

<script lang="ts">
    import {Component, Inject, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class CommissionAmount extends Vue {
        @Prop({required: true}) commission
        @Prop({required: false, type: Boolean}) showCommission
        @Inject({default: null}) searchRequest

        get visible() {
            return (
                (this.commission &&
                    authStore.companyType &&
                    authStore.companyType !== 'CORPORATE' &&
                    (this.searchRequest || this.$route.query)?.showCommission !== 'false') ||
                (this.commission &&
                    this.commissionAndNettoCheckbox &&
                    (this.searchRequest || this.$route.query)?.showCommission !== 'false')
            )
        }

        get commissionAndNettoCheckbox() {
            return persistentStore.commissionAndNettoCheckbox
        }
    }

    export default CommissionAmount
</script>

<style scoped>
    span.text-caption {
        line-height: 1rem;
    }
</style>
